/*
 * @Author: hanchunxuan 1627047609@qq.com
 * @Date: 2023-10-08 08:46:05
 * @LastEditors: hanchunxuan 1627047609@qq.com
 * @LastEditTime: 2023-10-14 10:25:41
 * @FilePath: \1008\zonghoutai-front\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AEre
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Layout from '../views/Layout/Index.vue'
import Home from '../views/Home/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'layout',
    component: Layout,
    isLogin:true,
    children:[
      {
        path: '/',
        name: 'home',
        component: Home,
        meta:{
          isLogin:true
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta:{
      isLogin:false
    },
    component: () => import( '../views/Login/Index.vue')
  },
  {
    path:'*',
    redirect:'/'
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



router.beforeEach((to,form,next)=>{
  let token = localStorage.getItem('mytoken') || ''
  if(!token){
    console.log('meiyoutoken');
      if(to.meta.isLogin){
        console.log('需要登录-去登录');
        next('/login')
      }else{
        console.log('不用登录-进');
        next()
      }
  }else{
    console.log('直接进');
    next()
  }


})

// // 获取原型对象上的push函数
// const originalPush = VueRouter.prototype.push
// // 修改原型对象中的push方法
// VueRouter.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default router
